import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Dialects from "@/components/landing/Dialects";
import Levels from "@/components/landing/Levels";
import Pricing from "@/components/landing/Pricing";
import Tutors from "@/components/landing/Tutors";
import HowItWorks from "@/components/landing/HowItWorks";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

const Landing = () => (
  <div className="grain min-h-screen bg-paper text-ink">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Dialects />
      <Levels />
      <Pricing />
      <Tutors />
      <HowItWorks />
      <Contact />
    </main>
    <Footer />
    <Toaster position="bottom-center" />
  </div>
);

export default Landing;
